import script from "./WorkCard.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkCard.vue?vue&type=script&setup=true&lang=js"

import "./WorkCard.vue?vue&type=style&index=0&id=2a6297dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a6297dd"]])

export default __exports__